/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_Paste_Text_HintInputs */

const en_home_v2_paste_text_hint = /** @type {(inputs: Home_V2_Paste_Text_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn raw text into audio`)
};

const es_home_v2_paste_text_hint = /** @type {(inputs: Home_V2_Paste_Text_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte texto en audio`)
};

/**
* | output |
* | --- |
* | "Turn raw text into audio" |
*
* @param {Home_V2_Paste_Text_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_paste_text_hint = /** @type {((inputs?: Home_V2_Paste_Text_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Paste_Text_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_paste_text_hint(inputs)
	return en_home_v2_paste_text_hint(inputs)
});